//src/components/Header.js

import React, { useContext, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCartShopping } from "@fortawesome/free-solid-svg-icons";
import { itemContext } from "../context/ItemContext";
import { Link, useNavigate } from "react-router-dom";

const Header = () => {
  const { itemsInCart } = useContext(itemContext);
  const [searchQuery, setSearchQuery] = useState("");
  const { user, handleLogout } = useContext(itemContext);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    navigate(`/search?query=${searchQuery}`);
  };

  return (
    <header>
      <nav className="navbar">
        <div className="navbar-brand">
          <h1 className="ecom">E-store</h1>
        </div>

        <div>
          <Link style={{ paddingRight: "20px" }} to="/">
            Home
          </Link>
          {user ? (
            <>
              <span>Welcome, {user.email}</span>
              <button onClick={handleLogout}>Logout</button>
            </>
          ) : (
            <>
              <Link to="/login">Login</Link>
              <Link to="/signup">Signup</Link>
            </>
          )}
        </div>

        <div></div>

        <div></div>

        <div>
          <form onSubmit={handleSearch}>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search products..."
            />
            <button type="submit">Search</button>
          </form>
        </div>

        <div className="navbar-items">
          <div>
            <Link to="/cart">Cart</Link>
          </div>
          <div className="cart-num">
            <FontAwesomeIcon icon={faCartShopping} size="2x" />
            <div className="cart-items" aria-label="items in cart">
              {itemsInCart}
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
